<template>
    <VirtualScrollTable
        :columns="columns"
        :data="subordinatesData"
        :columnHiddenOption="columnHiddenOption"
        :max-height="380"
        :checkbox-option="checkboxOption"
        :show-header="!isReadOnlyList"
    />
</template>

<script>
    import shareWatchListHelper from 'components/shared/mixins/shareWatchListHelper'
    import { mapGetters } from 'vuex'
    import VirtualScrollTable from 'components/user/watchlist/sharewatchlist/VirtualScrollTable'

    export default {
        name: 'ShareWatchListTableMobile',
        mixins: [ shareWatchListHelper ],
        components: {
            VirtualScrollTable
        },
        props: {
            subordinates: Array,
            isReadOnlyList: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                selectedSubordinates: 'Watchlists/getShareWatchListSelectedSubordinates',
                shareWatchListActiveTab: 'Watchlists/getShareWatchListTab',
                selectedMembers: 'Watchlists/getShareWatchListSelectedMembers',
            }),
            subordinatesData () {
                const subordinates = this.subordinates.map(subordinate => {
                    return {
                        ...subordinate,
                        rowKey: subordinate.userId
                    }
                })
                return subordinates
            },
        },
        data () {
            return {
                selectAllUsers: false,
                columnHiddenOption: {
                    defaultHiddenColumnKeys: [
                        this.isReadOnlyList ? 'checkbox' : ''
                    ],
                },
                checkboxOption: {
                    selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                        this.onAddOrRemoveSubordinate(row)
                    },
                    selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                        this.checked = isSelected
                        this.addAllSubordinates()
                    }
                },
                columns: [
                    {
                        field: '',
                        key: 'checkbox',
                        type: 'checkbox',
                        title: '',
                        width: 50,
                        align: 'center'
                    },
                    {
                        field: 'firstName',
                        key: 'firstName',
                        title: '',
                        align: 'left',
                        renderBodyCell: ({row, column, rowIndex}, h) => {
                            const emptyValues = [null, undefined, '']
                            const firstName = row[column.field]
                            const email = row.email
                            const lastName = row.lastName
                            const department = !emptyValues.includes(row.department) ? row.department : '-'
                            const team = !emptyValues.includes(row.team) ? row.team : '-'

                            const status = this.isSharedSubordinatesList
                                ?
                                <div class="share-watchlist-user-row__column-attribute --shared">
                                    <span class='icon-checkmark'></span>
                                    <span>{this.$t('WatchListModal.share_watchlist_tabs_shared')}</span>
                                </div>
                                :
                                <div class="share-watchlist-user-row__column-attribute --not-shared">
                                    <span>{this.$t('WatchListModal.share_watchlist_tabs_not_shared')}</span>
                                </div>

                            const statusRow = !this.isReadOnlyList ?
                                <div class="share-watchlist-user-row">
                                    <div class="share-watchlist-user-row__column-name">{this.$t('WatchListModal.share_watchlist_table_row_state')}</div>
                                    {status}
                                </div>
                                :
                                null

                            return (
                                <div>
                                    <div class="share-watchlist-user-row">
                                        <div class="share-watchlist-user-row__column-name">{this.$t('WatchListModal.share_watchlist_table_row_name')}</div>
                                        <div class="share-watchlist-user-row__column-attribute">{firstName} {lastName}</div>
                                    </div>
                                    <div class="share-watchlist-user-row">
                                        <div class="share-watchlist-user-row__column-name">{this.$t('WatchListModal.share_watchlist_table_row_email')}</div>
                                        <div class="share-watchlist-user-row__column-attribute">{email}</div>
                                    </div>
                                    <div class="share-watchlist-user-row">
                                        <div class="share-watchlist-user-row__column-name">{this.$t('WatchListModal.share_watchlist_table_row_department')}</div>
                                        <div class="share-watchlist-user-row__column-attribute">{department}</div>
                                    </div>
                                    <div class="share-watchlist-user-row">
                                        <div class="share-watchlist-user-row__column-name">{this.$t('WatchListModal.share_watchlist_table_row_team')}</div>
                                        <div class="share-watchlist-user-row__column-attribute">{team}</div>
                                    </div>
                                    {statusRow}
                                </div>
                            )
                        }
                    }
                ]
            }
        }
    }
</script>
